/**
 * @generated SignedSource<<77423bd45c0daa69c4e73af3df3ee110>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateCustomMcpServerInput = {
  authType: string;
  credentials?: string | null | undefined;
  description?: string | null | undefined;
  name: string;
  returnPath?: string | null | undefined;
  url: string;
};
export type McpServersOnboardingContentCreateMutation$variables = {
  input: CreateCustomMcpServerInput;
};
export type McpServersOnboardingContentCreateMutation$data = {
  readonly createCustomMcpServer: {
    readonly error: string | null | undefined;
    readonly oauthUrl: string | null | undefined;
    readonly server: {
      readonly id: any;
      readonly name: string;
    } | null | undefined;
  };
};
export type McpServersOnboardingContentCreateMutation = {
  response: McpServersOnboardingContentCreateMutation$data;
  variables: McpServersOnboardingContentCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CustomMcpServerPayload",
    "kind": "LinkedField",
    "name": "createCustomMcpServer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLCustomMcpServer",
        "kind": "LinkedField",
        "name": "server",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oauthUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "McpServersOnboardingContentCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "McpServersOnboardingContentCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5432c14a5c82c0fb2dd843c1c944b0b4",
    "id": null,
    "metadata": {},
    "name": "McpServersOnboardingContentCreateMutation",
    "operationKind": "mutation",
    "text": "mutation McpServersOnboardingContentCreateMutation(\n  $input: CreateCustomMcpServerInput!\n) {\n  createCustomMcpServer(input: $input) {\n    server {\n      id\n      name\n    }\n    error\n    oauthUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "0dae066fb538fac0b875ba2ebad6e1b5";

export default node;
